import { v4 as uuidV4 } from 'uuid';

export interface LogItem {
  fileName: string;
  tags: String[];
  columns: String[];
  message: string;
  payload?: any;
  timeStamp: number;
}

export type LogPayload = {
  logs: Array<LogItem>;
  id: string;
  name: string;
};

class Logger {
  private data: Array<LogItem> = [];
  private id: string = uuidV4();
  private name: string = '';
  log(
    fileName: string,
    tags: string[],
    columns: string[],
    message: string,
    timeStamp: number,
    payload?: any
  ) {
    const item = {
      fileName,
      tags,
      columns,
      message,
      payload,
      timeStamp,
    };
    this.data.push(item);
  }
  setName(name: string) {
    this.name = name;
  }
  getLogs() {
    return {
      logs: this.data,
      id: this.id,
      name: this.name,
    };
  }
}

const logInstance = new Logger();
(window as any).devLogInstance = logInstance;

class LogWrapper {
  constructor(
    public fileName: string,
    private _tags: string[],
    private _columns: LoggerColumns[]
  ) {}
  log(message: string, payload?: any) {
    const timeStamp = Date.now();
    console.log(`${this._tags.join(' ')} ${message}`, payload);
    logInstance.log(
      this.fileName,
      this._tags,
      this._columns.length > 0 ? this._columns : ['Default'],
      message,
      timeStamp,
      payload
    );
    return this;
  }
  tags(tags: string[]) {
    return new LogWrapper(this.fileName, tags, this._columns);
  }
  addTags(tags: string[]) {
    return this.tags([...this._tags, ...tags]);
  }
  columns(columns: LoggerColumns[]) {
    return new LogWrapper(this.fileName, this._tags, columns);
  }
  addColumns(columns: LoggerColumns[]) {
    return this.columns([...this._columns, ...columns]);
  }
  getLogs() {
    return logInstance.getLogs();
  }
  setName(name: string) {
    logInstance.setName(name);
    return this;
  }
}

export enum LoggerColumns {
  REDUX = 'REDUX',
  EXECUTOR = 'EXECUTOR',
  COMMUNICATION_ADAPTER = 'CMA',
  NOTS_WINDOW_RENDERER = 'N WindowRenderer',
  CONFIG = 'CONFIG',
}

type createLoggerOptions = {
  columns: LoggerColumns[];
  tags: string[];
};

const createLogger = (
  fileName: string,
  options: createLoggerOptions = { columns: [], tags: [] }
) => {
  const wrapper = new LogWrapper(fileName, options.tags, options.columns);
  return wrapper;
};

// export return type of createLogger
export type ILogger = ReturnType<typeof createLogger>;

export default createLogger;
